import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../animalTypeAction';

import fetchApi from './fetchApi';

function fetchAnimalTypeAction() {
  return fetchApi('/v1/fc_api/animal_type_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchAnimalTypeAction;
